import { useSelector } from "react-redux";
import { DegreeResponse } from "../../models/dtos";
import { RootState } from "../../store";
import { useAppDispatch } from "../../hooks/redux";
import { degreesApi } from "../../services/nomenclatures/degreesApi";
import { Skeleton } from "primereact/skeleton";
import Error from "../common/Error";
import FilterCard from "./FilterCard";
import FilterBox from "./FilterBox";

type DegreeFilterProps = {
  getSelectedDegrees: (state: RootState) => DegreeResponse[];
  setSelectedDegrees: any;
};

const DegreeFilter = ({ getSelectedDegrees, setSelectedDegrees }: DegreeFilterProps) => {
  const selectedDegrees = useSelector(getSelectedDegrees);
  const dispatch = useAppDispatch();

  const { data: degrees, error, isLoading } = degreesApi.useGetDegreesQuery(true);

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <FilterCard title="По образователна степен:">
      <FilterBox<DegreeResponse>
        value={selectedDegrees}
        onChange={(e) => dispatch(setSelectedDegrees(e.value))}
        options={degrees?.data ?? []}
        optionLabel="name"
        listClassName="max-h-20rem"
        dataKey="degreeId"
      />
    </FilterCard>
  );
};

export default DegreeFilter;
